const { CREATEACTAS, CREATEOT, CREATEENTRY, CREATEUSER, CREATECLIENT, CREATEITEM, CREATEMAG, CREATEROLE, APROVEEDITEM, CALIBRATE, PROGRAMOT, VIEWENTRY, VIEWROLE, VIEWCLIENT, VIEWCALENDAR, VIEWOT, TECNICHAL, CREATEPROGRAMACION, VIEWALLPROGRAMACION, VIEWPROGRAMACION, COMERCIAL, CREATEREGISTER, FINANCIAL,
VIEWREQUISICIONES, CREATEREQUISICION, APPROVEREQUISICION, EDITAR_REQUISICION, SELECCIONAR_GANADOR_REQUISICION, VIEWPROVEEDORES, CREATEPROVEEDOR, VIEW_PROPUESTAS, CREATE_PROPUESTAS, EDIT_PROPUESTAS, SEND_PROPUESTAS, DELETE_PROPUESTAS, SYNC_PROPUESTAS, VIEW_DASHBOARD_PROPUESTAS, MANAGE_PLANTILLA_PROPUESTAS, EMITIR_OC_REQUISICION, APROBAR_OC_REQUISICION, GESTIONAR_CERTS_REQUISICION,
GESTION_ENTREGAS,
GESTION_ERRORES,
CONFIGURACION_CONTABLE,
DASHBOARD_FINANCIERO,
COMPROBANTES_CONTABLES,
REVISION_RELACIONES,
GESTION_BOLSILLOS,
APPROVE_RELACIONES,
ACCIONES_SEGUIMIENTO_EQUIPO
 } = require('./ConstantRoute');

export const  Permisos =()=> {
   const ListaPermisos=[
    "",
    CREATEACTAS,
    CREATEENTRY,
    CREATEOT,
    CREATEUSER,
    CREATECLIENT,
    CREATEITEM,
    CREATEMAG,
    CREATEROLE,
    APROVEEDITEM,
    CALIBRATE,
    PROGRAMOT,
    VIEWENTRY,
    VIEWOT,
    VIEWCALENDAR,
    VIEWCLIENT,
    VIEWROLE,
    TECNICHAL,
    CREATEPROGRAMACION,
    VIEWPROGRAMACION,
    VIEWALLPROGRAMACION,
    COMERCIAL,
    VIEW_PROPUESTAS,
    EDIT_PROPUESTAS,
    CREATEREGISTER,
    FINANCIAL,
    VIEWREQUISICIONES,
    CREATEREQUISICION,
    EDITAR_REQUISICION,
    APPROVEREQUISICION,
    SELECCIONAR_GANADOR_REQUISICION,
    GESTIONAR_CERTS_REQUISICION,
    EMITIR_OC_REQUISICION,
    APROBAR_OC_REQUISICION,
    VIEWPROVEEDORES,
    CREATEPROVEEDOR,
    CREATE_PROPUESTAS,
    SEND_PROPUESTAS,
    DELETE_PROPUESTAS,
    SYNC_PROPUESTAS,
    VIEW_DASHBOARD_PROPUESTAS,
    MANAGE_PLANTILLA_PROPUESTAS,
    GESTION_ENTREGAS,
    GESTION_ERRORES,
    CONFIGURACION_CONTABLE,
    DASHBOARD_FINANCIERO,
    COMPROBANTES_CONTABLES,
    APPROVE_RELACIONES,
    REVISION_RELACIONES,
    GESTION_BOLSILLOS,
    ACCIONES_SEGUIMIENTO_EQUIPO
  ]
return(ListaPermisos)
}

